import connectToStores from 'alt-utils/lib/connectToStores';

function decorator(component) {
    const storeConnectionClass = connectToStores(component);

    const originalComponentWillReceiveProps = storeConnectionClass.prototype.componentWillReceiveProps;
    storeConnectionClass.prototype.UNSAFE_componentWillReceiveProps = originalComponentWillReceiveProps;

    delete storeConnectionClass.prototype.componentWillReceiveProps;
    return storeConnectionClass;
}

export default decorator;
